/**
 * Volt Pro - Premium Bootstrap 5 Dashboard
 * Converted from volt.js to TypeScript for Vite build
 */

document.addEventListener('DOMContentLoaded', function () {
    const d = document;

    const swalWithBootstrapButtons = (window as any).Swal?.mixin({
        customClass: {
            confirmButton: 'btn btn-primary me-3',
            cancelButton: 'btn btn-gray',
        },
        buttonsStyling: false,
    });

    const themeSettingsEl = document.getElementById('theme-settings');
    const themeSettingsExpandEl = document.getElementById('theme-settings-expand');

    if (themeSettingsEl) {
        const themeSettingsCollapse = new (window as any).bootstrap.Collapse(themeSettingsEl, {
            show: true,
            toggle: false,
        });

        if (window.localStorage.getItem('settings_expanded') === 'true') {
            themeSettingsCollapse.show();
            themeSettingsExpandEl?.classList.remove('show');
        } else {
            themeSettingsCollapse.hide();
            themeSettingsExpandEl?.classList.add('show');
        }

        themeSettingsEl.addEventListener('hidden.bs.collapse', function () {
            themeSettingsExpandEl?.classList.add('show');
            window.localStorage.setItem('settings_expanded', 'false');
        });

        themeSettingsExpandEl?.addEventListener('click', function () {
            themeSettingsExpandEl.classList.remove('show');
            window.localStorage.setItem('settings_expanded', 'true');
            setTimeout(function () {
                themeSettingsCollapse.show();
            }, 300);
        });
    }

    // options
    const breakpoints = {
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140,
    };

    const sidebar = document.getElementById('sidebarMenu');
    if (sidebar && d.body.clientWidth < breakpoints.lg) {
        sidebar.addEventListener('shown.bs.collapse', function () {
            document.querySelector('body')!.style.position = 'fixed';
        });
        sidebar.addEventListener('hidden.bs.collapse', function () {
            document.querySelector('body')!.style.position = 'relative';
        });
    }

    const iconNotifications = d.querySelector('.notification-bell');
    if (iconNotifications) {
        iconNotifications.addEventListener('shown.bs.dropdown', function () {
            iconNotifications.classList.remove('unread');
        });
    }

    [].slice.call(d.querySelectorAll('[data-background]')).map(function (el: HTMLElement) {
        el.style.background = 'url(' + el.getAttribute('data-background') + ')';
    });

    [].slice.call(d.querySelectorAll('[data-background-lg]')).map(function (el: HTMLElement) {
        if (document.body.clientWidth > breakpoints.lg) {
            el.style.background = 'url(' + el.getAttribute('data-background-lg') + ')';
        }
    });

    [].slice.call(d.querySelectorAll('[data-background-color]')).map(function (el: HTMLElement) {
        el.style.background = 'url(' + el.getAttribute('data-background-color') + ')';
    });

    [].slice.call(d.querySelectorAll('[data-color]')).map(function (el: HTMLElement) {
        el.style.color = 'url(' + el.getAttribute('data-color') + ')';
    });

    // Tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl: HTMLElement) {
        return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Popovers
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl: HTMLElement) {
        return new (window as any).bootstrap.Popover(popoverTriggerEl);
    });

    // Datepicker
    const datepickers = [].slice.call(d.querySelectorAll('[data-datepicker]'));
    datepickers.map(function (el: HTMLElement) {
        return new (window as any).Datepicker(el, {
            buttonClass: 'btn',
        });
    });

    if (d.querySelector('.input-slider-container')) {
        [].slice.call(d.querySelectorAll('.input-slider-container')).map(function (el: HTMLElement) {
            const slider = el.querySelector(':scope .input-slider') as HTMLElement;
            const sliderId = slider.getAttribute('id')!;
            const minValue = slider.getAttribute('data-range-value-min')!;
            const maxValue = slider.getAttribute('data-range-value-max')!;

            const sliderValue = el.querySelector(':scope .range-slider-value') as HTMLElement;
            const sliderValueId = sliderValue.getAttribute('id')!;
            const startValue = sliderValue.getAttribute('data-range-value-low')!;

            const c = d.getElementById(sliderId)!;

            (window as any).noUiSlider.create(c, {
                start: [parseInt(startValue)],
                connect: [true, false],
                range: {
                    min: [parseInt(minValue)],
                    max: [parseInt(maxValue)],
                },
            });
        });
    }

    if (d.getElementById('input-slider-range')) {
        const c = d.getElementById('input-slider-range')!;
        const low = d.getElementById('input-slider-range-value-low') as HTMLElement;
        const e = d.getElementById('input-slider-range-value-high') as HTMLElement;
        const f = [low, e];

        (window as any).noUiSlider.create(c, {
            start: [
                parseInt(low.getAttribute('data-range-value-low')!),
                parseInt(e.getAttribute('data-range-value-high')!),
            ],
            connect: true,
            tooltips: true,
            range: {
                min: parseInt(c.getAttribute('data-range-value-min')!),
                max: parseInt(c.getAttribute('data-range-value-max')!),
            },
        });
        (c as any).noUiSlider.on('update', function (a: string[], b: number) {
            f[b].textContent = a[b];
        });
    }

    // Chartist
    if (d.querySelector('.ct-chart-sales-value')) {
        new (window as any).Chartist.Line(
            '.ct-chart-sales-value',
            {
                labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                series: [[0, 10, 30, 40, 80, 60, 100]],
            },
            {
                low: 0,
                showArea: true,
                fullWidth: true,
                plugins: [(window as any).Chartist.plugins.tooltip()],
                axisX: {
                    position: 'end',
                    showGrid: true,
                },
                axisY: {
                    showGrid: false,
                    showLabel: false,
                    labelInterpolationFnc: function (value: number) {
                        return '$' + value / 1 + 'k';
                    },
                },
            }
        );
    }

    if (d.querySelector('.ct-chart-ranking')) {
        const chart = new (window as any).Chartist.Bar(
            '.ct-chart-ranking',
            {
                labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                series: [
                    [1, 5, 2, 5, 4, 3],
                    [2, 3, 4, 8, 1, 2],
                ],
            },
            {
                low: 0,
                showArea: true,
                plugins: [(window as any).Chartist.plugins.tooltip()],
                axisX: {
                    position: 'end',
                },
                axisY: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0,
                },
            }
        );

        chart.on('draw', function (data: any) {
            if (data.type === 'line' || data.type === 'area') {
                data.element.animate({
                    d: {
                        begin: 2000 * data.index,
                        dur: 2000,
                        from: data.path
                            .clone()
                            .scale(1, 0)
                            .translate(0, data.chartRect.height())
                            .stringify(),
                        to: data.path.clone().stringify(),
                        easing: (window as any).Chartist.Svg.Easing.easeOutQuint,
                    },
                });
            }
        });
    }

    if (d.querySelector('.ct-chart-traffic-share')) {
        const data = {
            series: [70, 20, 10],
        };

        const sum = function (a: number, b: number) {
            return a + b;
        };

        new (window as any).Chartist.Pie('.ct-chart-traffic-share', data, {
            labelInterpolationFnc: function (value: number) {
                return Math.round((value / data.series.reduce(sum)) * 100) + '%';
            },
            low: 0,
            high: 8,
            donut: true,
            donutWidth: 20,
            donutSolid: true,
            fullWidth: false,
            showLabel: false,
            plugins: [(window as any).Chartist.plugins.tooltip()],
        });
    }

    if (d.getElementById('loadOnClick')) {
        d.getElementById('loadOnClick')!.addEventListener('click', function () {
            const button = this as HTMLElement;
            const loadContent = d.getElementById('extraContent')!;
            const allLoaded = d.getElementById('allLoadedText')!;

            button.classList.add('btn-loading');
            button.setAttribute('disabled', 'true');

            setTimeout(function () {
                loadContent.style.display = 'block';
                button.style.display = 'none';
                allLoaded.style.display = 'block';
            }, 1500);
        });
    }

    new (window as any).SmoothScroll('a[href*="#"]', {
        speed: 500,
        speedAsDuration: true,
    });

    if (d.querySelector('.current-year')) {
        d.querySelector('.current-year')!.textContent = new Date().getFullYear().toString();
    }

    // Offer prices modal handler
    const modalOfferPrices = document.querySelector('#modal-offer-prices') as HTMLElement | null;
    if (modalOfferPrices) {
        const modal = new (window as any).bootstrap.Modal(modalOfferPrices);
        const tableBody = modalOfferPrices.querySelector('tbody')!;

        const populateTable = (item: any) => {
            tableBody.innerHTML += `
                <tr>
                    <td>${item.price}</td>
                    <td>${item.priceOverride}</td>
                    <td>${item.from}</td>
                    <td>${item.to}</td>
                    <td>${item.status}</td>
                </tr>
            `;
        };

        document.querySelectorAll('[data-show-offer-prices]').forEach((button) => {
            const prices = JSON.parse((button as HTMLElement).dataset.prices || '[]');

            button.addEventListener('click', () => {
                prices.forEach((item: any) => populateTable(item));
                modal.show();
            });
        });

        modalOfferPrices.addEventListener('hidden.bs.modal', () => {
            tableBody.innerHTML = '';
        });
    }
});
